import {useEffect, useState} from 'react';
import {useSearchParams} from 'react-router-dom';
import BreadCrumb from '../../components/breadCrumb';
import './style.scss';
import AssistenceItem from '../../components/assitenceAdmin/asistenceItem';
import {getMeetingsAttendance} from "../../API/apiService";
import Delete from "../../assets/icons/trash.svg";
import ModalContainer from "../../components/modalContainer";
import DeleteMeetingImageModal from "../../components/deleteMeetingImageModal";
import { buildProtectedImageUrl } from '../../utils/secureMedia';

function SingleAssistence() {
    // STATES //
    const [searchParams] = useSearchParams();
    const [querys, setQuerys] = useState('');
    const [meeting, setMeeting] = useState(null);
    const [meetingImages, setMeetingImages] = useState([]);
    const [facilitator, setFacilitator] = useState('');
    const [neighborhood, setNeighborhood] = useState('');
    const [municipality, setMunicipality] = useState('');
    const [meetingType, setMeetingType] = useState('');
    const [attendances, setAttendances] = useState([]);
    const [openModalDelete, setOpenModalDelete] = useState(false);
    const [selectedImageId, setSelectedImageId] = useState(null);
    function deleteRecord(id) {
        const index = attendances.findIndex(a => a.id === id);
        if (index !== -1) {
            const newAttendances = [...attendances];
            newAttendances.splice(index, 1);
            setAttendances(newAttendances);
        }
    }

    function openModal(selectedId) {
        setSelectedImageId(selectedId);
        setOpenModalDelete(true)
    }

    async function getInfo(meetingGroupId) {
        const meetingDetail = await getMeetingsAttendance(meetingGroupId);
        if (meetingDetail) {
            setMeetingImages(meetingDetail.meetingImages.map(i => {
                    return {
                        imageUrl: buildProtectedImageUrl(i.id, !!i.thumbnail),
                        id: i.id
                    }
                })
            );
            if (meetingDetail.meeting.meeting_date) {
                const index = meetingDetail.meeting.meeting_date.indexOf('T');
                if (index !== -1) {
                    meetingDetail.meeting.meeting_date = meetingDetail.meeting.meeting_date.substring(0, index);
                }
            }

            const meetingName = meetingDetail.meeting?.type === 'MEETING' ? 'Encuentro' : 'Evento';
            meetingDetail.meeting.meetingName = `${meetingName} ${meetingDetail.meeting?.order}`;

            setMeeting(meetingDetail.meeting);
            setAttendances(meetingDetail.attendances);
            setFacilitator(meetingDetail.meeting.group?.user?.full_name)
            setNeighborhood(meetingDetail.meeting.group?.neighborhood?.name ??
                meetingDetail.meeting.group?.school?.neighborhood?.name)
            setMunicipality(meetingDetail.meeting.group?.municipality?.name ??
                meetingDetail.meeting.group?.school?.municipality?.name)

            setMeetingType(meetingDetail.meeting.virtual ? 'Virtual' : 'Presencial')


        }
    }

    useEffect(() => {
        const entries = Object.fromEntries(searchParams);
        setQuerys(entries);
        getInfo(entries?.encuentro);
    }, []);

    return (
        <section className='singleAssitence-main-container'>
            <BreadCrumb/>
            {openModalDelete && (
                <ModalContainer>
                    <DeleteMeetingImageModal
                        meetingImageId={selectedImageId}
                        setOpenModalAdd={setOpenModalDelete}
                    />
                </ModalContainer>
            )}
            <div className='filters-container'>
                <div className='filters-top'>
                    <p className='title'>
                        {querys?.encuentro?.toUpperCase()} _ INFORMACIÓN GENERAL
                    </p>
                </div>
                <div className='filters-content'>
                    <div className='info-container '>
                        <label htmlFor='' className='school'>
                            <p className='input-title'>Proceso Formativo</p>
                            <input
                                type='text'
                                value={meeting?.group?.school?.code}
                                readOnly
                                className='input-form'
                            />
                        </label>
                        <label htmlFor='' className='minimun-label'>
                            <p className='input-title'>Grupo</p>
                            <input
                                type='text'
                                value={meeting?.group?.code}
                                readOnly
                                className='input-form'
                            />
                        </label>
                        <label htmlFor='' className='minimun-label'>
                            <p className='input-title'>Encuentro</p>
                            <input
                                type='text'
                                value={meeting?.meetingName}
                                readOnly
                                className='input-form'
                            />
                        </label>
                        <label htmlFor='' className='name'>
                            <p className='input-title'>Nombre del mediador</p>
                            <input
                                type='text'
                                value={facilitator}
                                readOnly
                                className='input-form'
                            />
                        </label>
                        <label htmlFor='' className='year'>
                            <p className='input-title'>Año</p>
                            <input
                                value={meeting?.group?.school?.year}
                                type='text'
                                readOnly
                                className='input-form'
                            />
                        </label>
                        <label htmlFor='' className='mode'>
                            <p className='input-title'>Modalidad</p>
                            <input
                                value={meetingType}
                                type='text'
                                readOnly
                                className='input-form'
                            />
                        </label>
                        <label htmlFor='' className='date'>
                            <p className='input-title'>Fecha</p>
                            <input
                                value={meeting?.meeting_date}
                                type='text'
                                readOnly
                                className='input-form'
                            />
                        </label>
                        <label htmlFor='' className='date'>
                            <p className='input-title'>Comuna</p>
                            <input
                                value={municipality}
                                type='text'
                                readOnly
                                className='input-form'
                            />
                        </label>
                        <label htmlFor='' className='date'>
                            <p className='input-title'>Barrio</p>
                            <input
                                value={neighborhood}
                                type='text'
                                readOnly
                                className='input-form'
                            />
                        </label>
                        <div className='notes-container'>
                            <label htmlFor=''>
                                <p className='input-title'>Objetivo</p>
                                <p className='notes'>{meeting?.goal}</p>
                            </label>
                        </div>
                        <div className='notes-container'>
                            <label htmlFor=''>
                                <p className='input-title'>Observaciones</p>
                                <p className='notes'>{meeting?.notes}</p>
                            </label>
                        </div>
                    </div>
                    <div className='photos-container'>
                        {meetingImages.map((imgInfo, index) => (
                                <div className='photos-container--div' key={index}>
                                    <img src={imgInfo.imageUrl} alt='meetingImg'/>
                                    <button onClick={()=>openModal(imgInfo.id)}>
                                        <img src={Delete} alt=''/>
                                    </button>
                                </div>
                            )
                        )}
                    </div>
                </div>
            </div>
            <section className='singleAsistence-container'>
                <div className='table-top'>
                    <p className='title'>ASISTENCIA DE BENEFICIARIOS</p>
                    <p className='pagination-text'>
                        | Mostrando <span>{attendances?.length}</span> resultados |
                    </p>
                </div>
                <div className='asistence-container'>
                    <AssistenceItem groupData={attendances} deleteRecord={deleteRecord}/>
                </div>
            </section>
        </section>
    );
}

export default SingleAssistence;
